import User from "@/store/models/user";
import axios from "@/store/vue-axios";
import {Model} from "@/store/models/model";



export class VserverOrderList extends Model {

  static entity = 'vserver_order_list'
  static primaryKey = 'product_key'

  static fields() {
    return {
      id: this.attr(null),
      title: this.attr(null),
      hostname: this.attr(null),
      hostname_group: this.attr(null),
      type: this.attr(null),
      memory: this.attr(null),
      cores: this.attr(null),
      disk: this.attr(null),
      max_backups: this.attr(null),
      max_scheduled_tasks: this.attr(null),
      backups:this.attr(null),
      addresses_v4:this.attr(null),
      start_at_boot: this.attr(null),
      traffic: this.attr(null),
      password: this.attr(null),
      reseller_accounting: this.attr(null),

      vserver_template: this.attr(null),

      created_at: this.attr(null),
      updated_at: this.attr(null),
      username: this.attr(null),
      user: this.belongsTo(User, 'username'),
      status: this.attr(null),
      //
      product_key:this.attr(null),
      product_name:this.attr(null),
      local_change:this.attr(null),
      order_status:this.attr(null),
      selected:this.attr(null),
      default_configuration:this.attr(null),
      fix_order:this.attr(null),
      price:this.attr(null),
      amount:this.number(1)
    }
  }

}

export default VserverOrderList



// WEBPACK FOOTER //
// ./src/store/models/vserver/vserver_order_list.js